import { type FC } from 'react';

import { WinWallOutcomes } from './WinWallOutcomes';
import { type WinWallHeroOrganizationOutcomeSummaryFragment } from './__generated-gql-types__/WinWallHero.generated';

interface WinWallHeroProps {
  outcomes: WinWallHeroOrganizationOutcomeSummaryFragment[];
  totalReviews: number;
}
export const WinWallHero: FC<WinWallHeroProps> = ({
  outcomes,
  totalReviews,
}) => {
  return (
    <section className="flex flex-col gap-12 bg-leland-beige py-12">
      <header className="mx-auto flex w-full flex-col gap-4 px-4 text-left sm:max-w-screen-2xl sm:items-start sm:px-14">
        <h1 className="flex items-center gap-3 sm:flex-row">
          <GradientText>{totalReviews.toLocaleString()}</GradientText>
          <span className="text-4xl font-medium sm:text-6xl">
            Leland Reviews
          </span>
        </h1>
        <div className="text-lg">
          See the latest outcomes and reviews from real Leland customers
        </div>
      </header>
      <WinWallOutcomes outcomes={outcomes} />
    </section>
  );
};

const GradientText: FC<{ children: string | number }> = ({ children }) => {
  return (
    <span className="inline-block bg-gradient-to-r from-leland-dark-green to-leland-primary bg-clip-text text-4xl font-semibold text-transparent sm:text-6xl">
      {children}
    </span>
  );
};
